export default "__VITE_ASSET__BY3ey8d2__"